module.exports = __webpack_public_path__ + "img/vu.859836e7.svg";